import { FormControl as FormControlMui, Grid } from '@mui/material';
import { styled } from '@mui/system';

export const FilterBar = styled(Grid)({
    paddingTop: '15px',
    paddingBottom: '15px',
    '& .MuiFormControl-root': {
        minWidth: '160px'
    }
});

export const FilterDropdown = styled(Grid)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-start'
    },
    [theme.breakpoints.up('sm')]: {
        justifyContent: 'flex-end'
    }
}));

export const FormControl = styled(FormControlMui)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        marginTop: '10px'
    },
    [theme.breakpoints.up('sm')]: {
        marginLeft: '10px'
    },
    width: 160
}));
